import BaseService from "@/services/BaseService";
import * as URI from "../bulkPayoutManualUpload/constant";

const action = {
  async getBulkPayoutUploadListAction({ commit }, payload) {
    let url = URI.BULK_PAYOUT_UPLOAD_LIST_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setBulkManualUploadList", response.data.data);
    return response.data.data;
  },
  async saveBulkPayoutUploadCsv({ commit }, payload) {
    const url = URI.BULK_PAYOUT_SAVE_CSV_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  },
  async downloadBulkPayoutExcel({ commit }, payload) {
    let url = URI.BULK_PAYOUT_EXCEL_URL;
    let response = {};
    try {
      response = await BaseService.getSchemePlanningClient().get(url, {
        responseType: "blob",
      });
    } catch (error) {
      response = await BaseService.getSchemePlanningClient().get(url);
    }
    return response;
  },
  async downloadBulkPayoutErrorExcel({ commit }, payload) {
    let manualUploadHdrIds = payload.selectedId
      .map((obj) => `manualUploadHdrIds=${obj}`)
      .join("&");
    let url = URI.BULK_PAYOUT_ERROR_EXCEL_URL.replace(
      "{manualUploadHdrIds}",
      manualUploadHdrIds
    );
    let response = {};
    try {
      response = await BaseService.getSchemePlanningClient().get(url, {
        responseType: "blob",
      });
    } catch (error) {
      response = await BaseService.getSchemePlanningClient().get(url);
    }
    return response;
  },
  async getFailedFilesListAction({ commit }, payload) {
    let url = URI.GET_FAILED_FILES_LIST_URL;
    let response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async downloadFailedFilesExcel({ commit }, payload) {
    let url = URI.GET_FAILED_FILES_DOWNLOAD_CSV_URL.replace(
      "{fileNameWithExt}",
      payload
    );
    let response = {};
    try {
      response = await BaseService.getSchemePlanningClient().get(url, {
        responseType: "blob",
      });
    } catch (error) {
      response = await BaseService.getSchemePlanningClient().get(url);
    }
    return response;
  },
  async getReleasePlansListAction({ commit }, payload) {
    let url = URI.GET_RELEASED_PLANS_LIST_URL.replace("{plan}", payload?.plan ? payload?.plan : "");
    let response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async releasePlansListAction({ commit }, payload) {
    const url = URI.SAVE_RELEASED_PLANS_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.plans,
    );
    return response;
  }
};

export default action;